import React, { useState } from "react";
import AppTranslation from "../../service/app_translation/AppTranslation";
import Scaffold from "../../widget/layouts/Scaffold";
import Center from "../../widget/common/ui/Center";
import Loader from "../../widget/common/ui/Loader";

type WebViewType = {
  title: string;
  url: string;
};

const WebViewScreen: React.FC<WebViewType> = ({ title, url }) => {
  const [loading, setLoading] = useState(true);

  const handleLoaded = () => {
    setLoading(false);
  };
  return (
    <Scaffold
      appBarTitle={AppTranslation.text(title)}
      isModal={true}
      bodyClass="overflow-hidden"
    >
      {loading && <Center className="h-100">{Loader.normal()}</Center>}
      <iframe
        onLoad={() => handleLoaded()}
        src={url}
        width={"100%"}
        //height={loading ? 0 : "100%"}
        title={AppTranslation.text(title)}
        style={{ border: "none", height: loading ? 0 : "100%" }}
      />
    </Scaffold>
  );
};
export default WebViewScreen;
